import ChatRoomComponent from '../components/units/ChatRoom/ChatRoom.Component';

export default function ChatRoomPage(): JSX.Element {
	return (
		<>
			<ChatRoomComponent />
		</>
	);
}
